<template>
  <div>
  <div>
    <date-period-select
      :presets="['yesterday','today','tomorrow','+week','+month']"
      init-preset="+week"
      v-on:input="changePeriod"></date-period-select>
  </div>
    <v-radio-group v-model="lessonsSet" row v-on:change="changeLessonsSet">
      <v-radio
        v-if="showAllLessons"
        label="Все занятия"
        value="all"
        ></v-radio>
      <v-radio
        label="Только мои"
        value="mine"
        ></v-radio>
    </v-radio-group>
    <v-pagination
      v-if="pagesCount>1"
      v-model="page"
      circle
      :length="pagesCount"
      v-on:input="loadLessons"
    ></v-pagination>
    <div class="body-2 mb-2">
      Записей на занятия:  <span class="green--text mr-2">{{ stats.records }}</span>
      Посещений: <span class="green--text mr-2">{{ stats.visits }}</span>
      Пропусков: <span class="red--text mr-2">{{ stats.lessonsLost }}</span>
      Из них по уваж. причине: <span class="green--text mr-2">{{ stats.goodReasons }}</span>
      <span v-if="stats.nonPayedLessons">
        Занятий в долг: <span class="red--text mr-2">{{ stats.nonPayedLessons }}</span>
      </span>
    </div>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

    <v-alert outlined type="warning"  v-if="!loading && lessons.length===0">
      Занятий не найдено
    </v-alert>
    <user-lesson-card
      v-for="lesson of lessons"
      :key="lesson.id"
      :show-date="true"
      :lesson="lesson"
      v-on:change="loadLessons"
      class="mb-2"></user-lesson-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DatePeriodSelect from '../DatePeriodSelect.vue';
import Lesson from '../../api/Lesson';
import UserLessonCard from '../lessons/UserLessonCard.vue';

const LESSONS_PER_PAGE = 25;

export default {
  name: 'UserJoinLessons',
  components: { UserLessonCard, DatePeriodSelect },
  props: ['join'],
  data: () => ({
    date1: null,
    date2: null,
    lessonsSet: 'all',
    loading: false,
    lessons: [],
    page: 1,
    stats: {},
  }),
  computed: {
    pagesCount() {
      return Math.ceil(this.stats.totalItems / LESSONS_PER_PAGE);
    },
    showAllLessons() {
      if (this.UISettings.disableJoinWithStatuses) {
        const statusIds = this.UISettings.joinStatusesDisabled || [];
        if (statusIds.includes(this.join.statusId)) {
          return false;
        }
      }
      return true;
    },
    ...mapGetters(['currentUser', 'UISettings']),
  },
  methods: {
    changeLessonsSet() {
      this.page = 1;
      this.loadLessons();
    },
    changePeriod(date1, date2) {
      this.page = 1;
      this.date1 = date1;
      this.date2 = date2;
      this.loadLessons();
    },
    async loadLessons() {
      if (!this.showAllLessons) {
        this.lessonsSet = 'mine';
      }

      this.loading = true;
      const filter = {
        date: [this.date1, this.date2],
        classId: this.join.classId,
        scopeUserId: this.currentUser.id,
        userId: this.lessonsSet === 'mine' ? this.currentUser.id : null,
        countFreeRecords: true,
        includeRecords: true,
        includeTasksLimited: true,
        includeMarks: true,
        includeParams: true,
        includeComments: true,
        includeTaskAnswers: true,
        includeFreezes: true,
        sort: 'date',
        limit: LESSONS_PER_PAGE,
        offset: (this.page - 1) * LESSONS_PER_PAGE,
      };
      const result = await Lesson.fetch(filter);
      const { lessons, stats } = result.data;
      this.lessons = lessons;
      this.stats = stats;
      this.loading = false;
    },
  },
};
</script>

<style scoped>

</style>
